import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SVGs } from "../assets";
import { Breadcrumbs, Card, Text } from "../components";
import { Constants } from "../utils";

export type SubRouteBreadcrumbRule = {
  pattern: string;
  key: string;
};

export type SubRouteLayoutProps = {};

export default function SubRouteLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const options = {
    dashboard: { label: t("general.operatorConsole"), path: "/" },
    booking: {
      label: t("general.booking"),
      path: Constants.RoutePath.Booking,
    },
    payment: { label: t("general.payment"), path: "/payment" },
  };
  const crumbs = ("dashboard/" + location.pathname)
    .split("/")
    .map((path) => options[path as keyof typeof options])
    .filter(Boolean);

  return (
    <div>
      <Breadcrumbs items={crumbs} className="sticky top-[80px] z-[90]" />
      <Card className="mx-[16px] mt-[16px] mb-[30px]">
        <div
          className="flex items-center gap-[16px] cursor-pointer "
          onClick={() => navigate(-1)}
        >
          <div className="flex justify-center items-center w-[40px] h-[40px] rounded-[30px] bg-background">
            <SVGs.LeftArrow className="h-4 w-4 text-secondary" />
          </div>
          <Text level={4} className="font-[700]">
            {t("general.back")}
          </Text>
        </div>
        <Outlet />
      </Card>
    </div>
  );
}
